import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { sounds } from '../../systems/AudioSystem';
import type { AssetsSchema } from '../../assetManifestTypes';

interface Ending {
  name: string;
  description: string;
  dramaticText: string;
}

interface EndingScreenProps {
  ending: Ending;
  onBack: () => void;
}

export const EndingScreen: React.FC<EndingScreenProps> = ({ ending, onBack }) => {
  const typedAssets = ASSETS as AssetsSchema;
  const backgroundAsset = typedAssets.backgrounds?.main_menu_neural_network;

  return (
    <div
      className="menu-screen"
      style={{
        backgroundImage: backgroundAsset ? `url(${backgroundAsset.path})` : undefined,
      }}
    >
      <div className="menu-screen-content">
        <h2 className="text-red-500">{ending.name}</h2>
        <p className="text-center my-4 italic">"{ending.dramaticText}"</p>
        <p className="text-center">{ending.description}</p>
      </div>
      <button 
        className="menu-button mt-8" 
        onClick={() => {
          sounds.buttonClick();
          onBack();
        }}
        onMouseEnter={() => sounds.menuHover()}
      >
        {CONSTANTS.MAIN_MENU.backButtonText}
      </button>
    </div>
  );
};
